<template>
    <div>
        <v-form @submit.prevent="submitForm">
            <v-row>
                <v-col>
                    <div class="text-h5 text-center">Forgot Password</div>
                </v-col>
            </v-row>
            <v-row v-if="alert.show">
                <v-col>
                    <v-alert :type="alert.type">{{ alert.message }}</v-alert>
                </v-col>
            </v-row>
            <div v-if="showForm">
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Email"
                            variant="underlined"
                            color="primary"
                            v-model="form.email"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-btn
                            color="primary"
                            type="submit"
                            :disabled="processing"
                            block
                        >
                            Send Reset Link
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
            <v-row v-if="!showForm">
                <v-col>
                    <Link
                        :href="route('index')"
                    >
                        <v-btn
                            color="secondary"
                            block
                        >
                            Go to login
                        </v-btn>
                    </Link>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import {Link} from "@inertiajs/inertia-vue3";

export default {
    name: "ForgotPasswordForm",
    components: {Link},
    data() {
        return {
            form: {
                email: null
            },
            showForm: true,
            processing: false,
            alert: {
                type: 'danger',
                message: null,
                show: false
            }
        }
    },
    methods: {
        submitForm() {
            this.processing = true
            axios.post(route('password.email'), this.form)
                .then((response) => {
                    // HANDLE SUCCESS
                    this.alert.message = `Password reset submitted successfully. An email has been sent to ${this.form.email}. Please follow the link in the email to reset your password.`
                    this.alert.type = 'success'
                    this.alert.show = true
                    this.showForm = false
                })
                .catch((object) => {

                    if (object.response.status === 422) {
                        this.alert.message = object.response.data.message
                        this.alert.type = 'error'
                        this.alert.show = true
                    }
                    if (object.response.status === 400) {
                        this.alert.message = object.response.data
                        this.alert.type = 'error'
                        this.alert.show = true
                    }
                    if (object.response.status === 500) {
                        this.alert.message = 'There was an error sending the email.'
                        this.alert.type = 'error'
                        this.alert.show = true
                    }
                })
                .finally(() => {
                    this.processing = false
                })
        }
    }
}
</script>

<style scoped>

</style>
